import { render, staticRenderFns } from "./MyImgText2.vue?vue&type=template&id=20c4afb0&scoped=true"
import script from "./MyImgText2.vue?vue&type=script&lang=js"
export * from "./MyImgText2.vue?vue&type=script&lang=js"
import style0 from "./MyImgText2.vue?vue&type=style&index=0&id=20c4afb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4afb0",
  null
  
)

export default component.exports